import { render, staticRenderFns } from "./VesselAuditHistory.vue?vue&type=template&id=4ffed4f6&scoped=true&"
import script from "./VesselAuditHistory.vue?vue&type=script&lang=js&"
export * from "./VesselAuditHistory.vue?vue&type=script&lang=js&"
import style0 from "./VesselAuditHistory.vue?vue&type=style&index=0&id=4ffed4f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffed4f6",
  null
  
)

export default component.exports